import type { CareProtocolOpportunityListItem } from "@elation/api-client/src/stitch-web/models";

export type CareProtocolOpportunityPatientGroup = {
  patient: CareProtocolOpportunityListItem["patient"];
  items: CareProtocolOpportunityListItem[];
};

export type CareProtocolOpportunityDateGroup = {
  date: string;
  uploadedAt: string;
  items: CareProtocolOpportunityListItem[];
};

export function groupCareProtocolOpportunitiesByPatient(
  items: CareProtocolOpportunityListItem[],
): CareProtocolOpportunityPatientGroup[] {
  const groups = new Map<number, CareProtocolOpportunityPatientGroup>();

  for (const item of items) {
    const group = groups.get(item.patient.id) ?? {
      patient: item.patient,
      items: [],
    };
    group.items.push(item);
    groups.set(item.patient.id, group);
  }

  return [...groups.values()];
}

export function groupCareProtocolOpportunitiesByDate(
  items: CareProtocolOpportunityListItem[],
): CareProtocolOpportunityDateGroup[] {
  const groups = new Map<string, CareProtocolOpportunityDateGroup>();

  for (const item of items) {
    const date = item.createdAt.slice(0, 10);
    const group = groups.get(date) ?? {
      date,
      uploadedAt: item.createdAt,
      items: [],
    };
    group.items.push(item);
    groups.set(date, group);
  }

  return [...groups.values()];
}
